import React, { useState, useEffect } from 'react';
import {
    EuiButton, EuiButtonEmpty,
    EuiComboBox, EuiFieldPassword,
    EuiFieldText,
    EuiForm,
    EuiFormRow,
    EuiLoadingSpinner, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle,
    EuiPanel,
    EuiSpacer,
    EuiTable,
    EuiTableBody,
    EuiTableHeader,
    EuiTableHeaderCell,
    EuiTableRow,
    EuiTableRowCell, EuiText, EuiFieldNumber, EuiProgress
} from '@elastic/eui';

interface Batch {
    batchId: number;
    batchName: string;
    createdDate: string;
    numberOfPins: number;
    status: string;
}
interface BatchTableChild {
    onChildChange: () => void;
    batches: Batch[]
}
interface Pin {
    pinId: number;
    batchId: number;
    activationStatus: string;
    activationDate: string;
    saleStatus: string;
}



export  const BatchTable: React.FC<BatchTableChild> = ({ onChildChange , batches }) => {
    const [banBatchModal,setBanBatchModal] = useState(false)
    const [selectedBatchId,setSelectedBatchId] = useState<number>()
    const [isCreateModalVisible,setIsCreateModalVisible] = useState(false);
    const [loadingCreateBatch,setLoadingCreateBatch] = useState(false);
    const [batchName,setBatchName] = useState("");
    const [numberOfPin, setNumberOfPin] = useState(0);
    const [durationInDays, setDurationInDays] = useState(30);
    const [isPinModalOpen, setIsPinModalOpen] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [resultList, setResultList] = useState<Pin[]>([]);


    const openModal = async (rowId: number) => {



        await getPin(rowId)
        setIsPinModalOpen(true);

    };

    const closeModal = () => {
        setSelectedRowId(null);
        setIsPinModalOpen(false);
    };

    const handleCopyPins = () => {
        const pinsToCopy = resultList.filter((pin) => pin.saleStatus === 'FOR_SALE').map((pin) => pin.pinId);


        console.log(pinsToCopy)

        const pinsText = pinsToCopy.join('\n');

        navigator.clipboard.writeText(pinsText)
            .then(() => {
                console.log('Pins copied to clipboard:', pinsText);
            })
            .catch((error) => {
                console.error('Error copying pins to clipboard:', error);
            });
    };


    const onNChange = (n:any) => {
        setNumberOfPin(n.target.value);
    };

    const onDurationChange = (n:any) => {
        setDurationInDays(n.target.value);
    };





    const getPin = async (rowId : number) => {
        console.log(rowId)

            setIsDataLoading(true);


            const token = localStorage.getItem('token');

            const requestBody = {
                batchId: rowId,
            };

            try {

                const response = await fetch('/api/v1/pin/multiplepin', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(requestBody),
                });

                if (response.ok) {
                    const data = await response.json();
                    setResultList(data);
                    setIsPinModalOpen(true);
                } else {

                    console.error('API Error:', response.status);
                }
            } catch (error) {

                console.error('Error:', error);
            }

            setIsDataLoading(false);

    };



let val;





    async function changeStatusOfBatch(batchId: any) {
        const token = localStorage.getItem('token');
        const response = await fetch('/api/v1/batch/banbatch', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({batchId: selectedBatchId }),
        });
        const data = await response.json();
        alert(data.message)
        onChildChange();
        setBanBatchModal(false)


    }

    if(banBatchModal){
        let filteredArray = batches.filter((obj)=> obj.batchId == selectedBatchId);
        let stat;
        if(filteredArray[0].status == "ACTIVE"){
            stat ="BANNED"
        }else {
            stat = "ACTIVE"
        }

        val = ( <EuiModal onClose={() => setBanBatchModal(false)}>
            <EuiModalHeader>
                <EuiModalHeaderTitle>Change the status of batch</EuiModalHeaderTitle>
            </EuiModalHeader>
            <EuiModalBody>
                the status of batch with Id {filteredArray[0].batchId} will be changed from {filteredArray[0].status} to {stat}
            </EuiModalBody>
            <EuiModalFooter>
                <EuiButtonEmpty onClick={() => setBanBatchModal(false)}>Cancel</EuiButtonEmpty>
                <EuiButton onClick={changeStatusOfBatch} fill>
                    Confirm
                </EuiButton>
            </EuiModalFooter>
        </EuiModal>)
    }

    function handleDisableBatch(batchId: number) {
        setSelectedBatchId(batchId);
        setBanBatchModal(true);

    }

    async function createBatch() {
        setLoadingCreateBatch(true)

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/v1/batch/create', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({numberOfPins: numberOfPin ,batchName: batchName,durationInDays: durationInDays}),
            });
            const data = await response.json();
            alert(data.status)
            onChildChange();
            setLoadingCreateBatch(false)
            setIsCreateModalVisible(false)
        } catch (error) {
            console.error('Error creating Batch:', error);
            setLoadingCreateBatch(false);
        }


    }

    return (
        <div>
            <EuiButton onClick={()=>{setIsCreateModalVisible(true)}} fill>
                Create New Batch
            </EuiButton>
        <EuiTable>
            <EuiTableHeader>
                <EuiTableHeaderCell>Batch ID</EuiTableHeaderCell>
                <EuiTableHeaderCell>Batch Name</EuiTableHeaderCell>
                <EuiTableHeaderCell>Created Date</EuiTableHeaderCell>
                <EuiTableHeaderCell>Number of Pins</EuiTableHeaderCell>
                <EuiTableHeaderCell>Activation Status</EuiTableHeaderCell>
                <EuiTableHeaderCell>Action</EuiTableHeaderCell>
                <EuiTableHeaderCell>Pin</EuiTableHeaderCell>
            </EuiTableHeader>

                {batches.map((batch) => (
                    <EuiTableRow key={batch.batchId}>
                        <EuiTableRowCell>{batch.batchId}</EuiTableRowCell>
                        <EuiTableRowCell>{batch.batchName}</EuiTableRowCell>
                        <EuiTableRowCell>{batch.createdDate}</EuiTableRowCell>
                        <EuiTableRowCell>{batch.numberOfPins}</EuiTableRowCell>
                        <EuiTableRowCell>
              <span style={{ color: batch.status === 'ACTIVE' ? 'green' : 'red' }}>
                {batch.status}
              </span>
                        </EuiTableRowCell>
                        <EuiTableRowCell>
                            <EuiButton size="s" onClick={() => handleDisableBatch(batch.batchId)}>
                                Change Status
                            </EuiButton>
                        </EuiTableRowCell>
                        <EuiTableRowCell>
                            <EuiButton size="s" onClick={() => openModal(batch.batchId)}>
                                See pin
                            </EuiButton>
                        </EuiTableRowCell>
                    </EuiTableRow>
                ))}

        </EuiTable>
            {val}
            {isCreateModalVisible && (
                <EuiModal onClose={() => setIsCreateModalVisible(false)}>

                    <EuiModalHeader>
                        <EuiModalHeaderTitle>Create New Batch</EuiModalHeaderTitle>
                    </EuiModalHeader>
                    {loadingCreateBatch ? (
                        <EuiProgress size="xs" color="accent" />):(
                    <EuiModalBody>

                        <EuiFieldText
                            placeholder="Batch Name"
                            type='dual'
                            value={batchName}
                            onChange={(e) => setBatchName(e.target.value)}
                            aria-label="Use aria labels when no actual label is in use"
                        />

                        <EuiSpacer />

                        <EuiText >Number of pins :</EuiText>

                        <EuiSpacer />
                        <EuiFieldNumber
                            title={"Number of pins :"}
                            placeholder="Enter the Number of pins"
                            value={numberOfPin}
                            onChange={(n) => onNChange(n)}
                        />

                        <EuiSpacer />

                        <EuiText >Pin validity in days :</EuiText>

                        <EuiSpacer />

                        <EuiFieldNumber
                            placeholder="Enter the duration of pins in days"
                            value={durationInDays}
                            onChange={(n) =>onDurationChange(n)}
                        />

                    </EuiModalBody>)}
                    <EuiModalFooter>
                        <EuiButtonEmpty onClick={() => setIsCreateModalVisible(false)}>Cancel</EuiButtonEmpty>
                        <EuiButton onClick={createBatch} fill>
                            Create
                        </EuiButton>
                    </EuiModalFooter>
                </EuiModal>
            )}
            {isPinModalOpen && ( <EuiModal onClose={closeModal}>
                <EuiModalHeader>
                    <EuiModalHeaderTitle>Pin Details</EuiModalHeaderTitle>
                </EuiModalHeader>
                <EuiModalBody>
                    {isDataLoading ? (
                        <EuiProgress size="xs" color="accent" />
                    ) : (
                        <EuiTable>
                            <EuiTableHeader>
                                <EuiTableHeaderCell>Pin ID</EuiTableHeaderCell>
                                <EuiTableHeaderCell>Batch ID</EuiTableHeaderCell>
                                <EuiTableHeaderCell>Activation Status</EuiTableHeaderCell>
                                <EuiTableHeaderCell>Activation Date</EuiTableHeaderCell>
                                <EuiTableHeaderCell>Sale Status</EuiTableHeaderCell>
                            </EuiTableHeader>

                                {resultList.map((pin) => (
                                    <EuiTableRow key={pin.pinId}>
                                        <EuiTableRowCell>{pin.pinId}</EuiTableRowCell>
                                        <EuiTableRowCell>{pin.batchId}</EuiTableRowCell>
                                        <EuiTableRowCell>{pin.activationStatus}</EuiTableRowCell>
                                        <EuiTableRowCell>{pin.activationDate}</EuiTableRowCell>
                                        <EuiTableRowCell>{pin.saleStatus}</EuiTableRowCell>
                                    </EuiTableRow>
                                ))}

                        </EuiTable>
                    )}
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButton onClick={handleCopyPins} name="copyPinsButton">
                        Copy Pins
                    </EuiButton>
                </EuiModalFooter>
            </EuiModal> )}
        </div>
    );
};
